import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading text-center mb-8">
          探索分类
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-background-50 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 text-xl">
                <i className={cat.icon}></i>
              </span>
              <div className="text-center">
                <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors font-heading block">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-500 mt-0.5">
                  {cat.articleCount} 篇文章
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}